{
  "days": {
    "Monday": "Monday",
    "Tuesday": "Tuesday",
    "Wednesday": "Wednesday",
    "Thursday": "Thursday",
    "Friday": "Friday",
    "Saturday": "Saturday",
    "Sunday": "Sunday"
  },
  "months": {
    "January": "January",
    "February": "February",
    "March": "March",
    "April": "April",
    "May": "May",
    "June": "June",
    "July": "July",
    "August": "August",
    "September": "September",
    "October": "October",
    "November": "November",
    "December": "December"
  },
  "actions": {
    "StartReading": "Start Reading",
    "PreviewEdition": "Preview Edition",
    "Download": "Download",
    "Retry": "Retry",
    "ReadePaper": "Read e-Paper",
    "TryAgain": "Try Again"
  },
  "preview": {
    "bottomBar": {
      "subscribe": "Learn about subscription",
      "login": "Already a subscriber? Log in"
    },
    "gate": {
      "title": "Subscribe to view the archive",
      "body": "Subscribers get the full edition, offline reading and sharing, plus archive access.",
      "cta": "Learn about subscription"
    }
  },
  "multiTitle": {
    "st": "",
    "zb": "联合早报",
    "bh": "",
    "tm": "தமிழ் முரசு",
    "sm": "新明日报",
    "bt": "",
    "bm": "",
    "mm": "",
    "tabla": "Tabla!"
  },
  "tooltip": {
    "Logout": "Log out",
    "Onboarding": "Tips",
    "CalenderView": "Calendar View",
    "TileView": "Cover View",
    "StartReading": "Click to read"
  },
  "nav": {
    "Logout": "Logout",
    "Calendar": "Calendar",
    "Archive": "Archive"
  }
}
